module.exports = __webpack_public_path__ + "static/media/notice_assurance.9ed27071.pdf";